import { createContext, useContext, useState, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { styles } from './pdf-generation-context.styles'

interface PDFGenerationContextValue {
  showOverlay: () => void
  hideOverlay: () => void
  isGenerating: boolean
}

const PDFGenerationContext = createContext<PDFGenerationContextValue | undefined>(undefined)

export function usePDFGenerationContext() {
  const context = useContext(PDFGenerationContext)
  if (!context) {
    throw new Error('usePDFGenerationContext must be used within PDFGenerationProvider')
  }
  return context
}

interface PDFGenerationProviderProps {
  children: ReactNode
}

export function PDFGenerationProvider({ children }: PDFGenerationProviderProps) {
  const [isGenerating, setIsGenerating] = useState(false)

  const showOverlay = () => {
    setIsGenerating(true)
  }

  const hideOverlay = () => {
    setIsGenerating(false)
  }

  return (
    <PDFGenerationContext.Provider value={{ showOverlay, hideOverlay, isGenerating }}>
      {children}
      {isGenerating &&
        createPortal(
          <Backdrop open={isGenerating} sx={styles.backdrop}>
            <CircularProgress color="inherit" />
            <Typography variant="h6" color="inherit">
              Capturing PDF Content...
            </Typography>
          </Backdrop>,
          document.body
        )}
    </PDFGenerationContext.Provider>
  )
}
